import React from 'react';
import Checkbox from 'legacy/src/components/Checkbox';
import './style.scss';

const PerformanceFilters = ({ checkedItems, setCheckedItems }) => (
  <div className="performanceFiltersContainer">
    <div className="performanceFiltersHeader">
      Average Cumulative Performance
    </div>
    <div className="performanceFiltersBody">
      <div className="quartileContainer">
        <div
          role="img"
          aria-label="Not assessed"
          className="quartileIndicator--notAssessed"
        />
        <span>Not Assessed</span>
        <Checkbox
          backgroundColor="#015CB0"
          width={22}
          height={22}
          onClick={() => {
            setCheckedItems({
              ...checkedItems,
              notAssessed: !checkedItems.notAssessed,
            });
          }}
          checked={checkedItems.notAssessed}
        />
      </div>
      <div className="quartileContainer">
        <div
          role="img"
          aria-label="0 - 24.99%"
          className="quartileIndicator quartileIndicator--first"
        />
        <span>0 - 24.99%</span>
        <Checkbox
          backgroundColor="#015CB0"
          width={22}
          height={22}
          onClick={() => {
            setCheckedItems({
              ...checkedItems,
              firstQuartile: !checkedItems.firstQuartile,
            });
          }}
          checked={checkedItems.firstQuartile}
        />
      </div>
      <div className="quartileContainer">
        <div
          role="img"
          aria-label="25 to 49.99%"
          className="quartileIndicator quartileIndicator--second"
        />
        <span>25 - 49.99%</span>
        <Checkbox
          backgroundColor="#015CB0"
          width={22}
          height={22}
          onClick={() => {
            setCheckedItems({
              ...checkedItems,
              secondQuartile: !checkedItems.secondQuartile,
            });
          }}
          checked={checkedItems.secondQuartile}
        />
      </div>
      <div className="quartileContainer">
        <div
          role="img"
          aria-label="50 to 74.99%"
          className="quartileIndicator quartileIndicator--third"
        />
        <span>50 - 74.99%</span>
        <Checkbox
          backgroundColor="#015CB0"
          width={22}
          height={22}
          onClick={() => {
            setCheckedItems({
              ...checkedItems,
              thirdQuartile: !checkedItems.thirdQuartile,
            });
          }}
          checked={checkedItems.thirdQuartile}
        />
      </div>
      <div className="quartileContainer">
        <div
          role="img"
          aria-label="75 to 100%"
          className="quartileIndicator quartileIndicator--fourth"
        />
        <span>75 - 100%</span>
        <Checkbox
          backgroundColor="#015CB0"
          width={22}
          height={22}
          onClick={() => {
            setCheckedItems({
              ...checkedItems,
              fourthQuartile: !checkedItems.fourthQuartile,
            });
          }}
          checked={checkedItems.fourthQuartile}
        />
      </div>
    </div>
  </div>
);

export default PerformanceFilters;
